module.exports = __webpack_public_path__ + "media/images/platforms/pc/square-319fbe214f019780454355249b8e652f.jpg";